import { memo, useEffect, useState } from "react";

import { CartUpsellsView } from "@cart/CartUpsells/CartUpsells.view";
import { CartUpsellsAnalytics } from "@cart/CartUpsells/CartUpsellsAnalytics.data";
import { useCartUpsells } from "@react/hooks/useCartUpsells";
import { useSectionSettings } from "@sections/Root/SectionSettingsContext";
import { type CartSectionSettings } from "@tablescape/state";

type Props = {
  badgeText: string | undefined;
  btnAddLabel?: string;
  bundleValueText: string;
  headingText: string;
};

const CartUpsellsBase = ({
  badgeText,
  btnAddLabel,
  bundleValueText,
  headingText,
}: Props) => {
  const {
    settings: {
      baseDrawer: { upsellDataApiEnabled },
    },
  } = useSectionSettings<CartSectionSettings>();

  const { dataDrivenUpsells, upsellProducts: dataDrivenUpsellProducts } =
    useCartUpsells({
      limit: 5,
      upsellDataApiEnabled,
    });

  const [upsellMetadata, setUpsellMetadata] =
    useState<typeof dataDrivenUpsellProducts>();

  useEffect(() => {
    if (!dataDrivenUpsellProducts) {
      return;
    }

    requestAnimationFrame(() => setUpsellMetadata(dataDrivenUpsellProducts));
  }, [dataDrivenUpsellProducts]);

  return (
    <>
      <CartUpsellsView
        badgeText={badgeText}
        btnAddLabel={btnAddLabel}
        bundleValueText={bundleValueText}
        headingText={headingText}
        upsellMetadata={upsellMetadata}
      />

      <CartUpsellsAnalytics
        dataDrivenUpsells={dataDrivenUpsells}
        upsellMetadata={upsellMetadata}
      />
    </>
  );
};

export const CartUpsells = memo(CartUpsellsBase);
